<template>
  <div class="cbox">
    <div class="w_100 h_100 bcontent flexStart borderbox" style="padding:20px 0;">
      <div class="flex_1 h_100 flexCloumn" style="overflow:auto;">
      <div class="w_100 headbar flexBetween" style="padding:0;border:0;">
        <div class="flexStart flex_1 w_100" style="flex-wrap:wrap;">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </div>
      </div>
      <el-table :data="dataList" height="100%" size="small" stripe border style="width:fit-content;width:100%;">
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="school_name" label="学校名称" ></el-table-column>
        <el-table-column prop="cert_name" label="证书名称"></el-table-column>
        <el-table-column prop="levels" label="证书等级" ></el-table-column>
        <el-table-column prop="fzdw" label="发证单位"></el-table-column>
        <el-table-column fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>

        </el-table-column>
      </el-table>
      <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange"
                     :current-page="page.current_page" :page-size="page.per_page" :total="page.count"
                     layout="total, sizes,prev, pager, next" :page-sizes="[10, 20, 50, 100]" style="margin-top: 10px;">
      </el-pagination>
      </div>
    </div>

    <!--    查看-->
    <el-dialog class="cus_dialog " title="其他证书" :visible.sync="dialogVisible" :close-on-click-modal="false"
               width="800px">
      <el-form :model="formData" ref="ruleForm" label-width="100px" :rules="rules">

        <el-form-item label="证书名称" prop="cert_name">
          <el-input v-model.trim="formData.cert_name" placeholder="证书名称" />
        </el-form-item>
        <el-form-item
          v-for="(level, index) in formData.levels"
          :label="'等级' + index"
          :key="index"
          :prop="'levels.' + index + '.value'">
          <el-input v-model.trim="level.value" placeholder="证书等级" style="width: 85%;" />
          <el-button v-if="formData.levels.length > 1" type="danger" style="margin-left: 10px" @click="removeItem(index)">删除</el-button>
        </el-form-item>
        <el-form-item label="发证单位" prop="fzdw">
          <el-input v-model.trim="formData.fzdw" placeholder="请输入发证单位" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button size="small" type="primary" plain @click="addItem">新增等级</el-button>
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    </div>
</template>

<script>
export default {
  components: { },
  data() {
    return {
      dialogVisible: false,
      target_teachers: "",
      target_classes: "",
      choosedTeachers: 0,
      choosedClasses: 0,
      choosedStuCount: 0,
      choosedParentCount: 0,
      hasteacher: false,
      showAnswer: false,

      page: {
        count: 0,
        current_page: 1,
        per_page: 50,
        total_page: 0
      },

      dataList: [],
      formData: {
        levels: [{value:""}],
      },
      ruleForm: {
        sort: 1,
        formal: 1,
        open: 0,
        moban_arr: [{
          type: 0,
          send_type: 2,
          checkAll: true,
          isIndeterminate: false,
          selectCoList: [],
        }],
      },
      // isIndeterminate: false,
      // checkAll: true,
      showDialog_co: false,
      coList: [],
      indexCo: 0,
      // selectCoList:[],
      colorList: ['#67c23a', '#f56c6c', '#409eff',],
      rules: {
        cert_name: [{
          required: true,
          message: "请输入证书名称",
          trigger: "blur"
        },],
      },
      showDialog: false,
      showSms: false,
      dialodTitle: '问卷计划新增',
      moban_list00: [], //学生
      moban_list02: [], //企业
      moban_list01: [], //家长
      props: {
        multiple: true,
        emitPath: false,
        value: 'id',
        label: 'stu_name'
      },

      studentsTree: [],
      showDialog_preview: false,
      showDialog_complete: false,
      viewTitle: '',
      showDialog_report2: false,
      reportTitle: '',
      active_report: 'first',
      tempList: [],
      ids: [],
      tmOne: {},

      list: [],
      gkInfo: {},
      tjTmlist: [],
      hasXX: false,
      wordsList: [],
      ckdViewIvstID: [],
      plan_id: 0,
      completeList: [],
      defaultProps: {
        children: 'arr',
        label: 'name'
      },
      rateList: [],
      expandedKeys: [],
      teacherInfo: {},
      showJoinReport: false,
      showJoinReportEnt: false,
      showDialog_report: false,
      ckdTmrow: 0,
      ckdTmTitle: "",
      gyears: [],
      answers: [],
      selectRow: [],
      schoolList: [],
      searchForm: {
        npmid: "",
      },
      SchoolList: [],
      schoolId: 'all',
      majorTypes: [
        "农林牧渔大类",
        "资源环境与安全大类",
        "能源动力与材料大类",
        "土木建筑大类",
        "水利大类",
        "装备制造大类",
        "生物与化工大类",
        "轻工纺织大类",
        "食品药品与粮食大类",
        "交通运输大类",
        "电子与信息大类",
        "医药卫生大类",
        "财经商贸大类",
        "旅游大类",
        "文化艺术大类",
        "新闻传播大类",
        "教育与体育大类",
        "公安与司法大类",
        "公共管理与服务大类"
      ],
    };
  },
  mounted() {
    // console.log(sessionStorage.getItem("auth"));
    this.getInfo()
    this.getlist();
    this.getSchoolList()
    //this.getStudentsTree()
  },
  methods: {
    addItem() {
      this.formData.levels.push({value:""})
    },
    removeItem(idx) {
      this.formData.levels.splice(idx,1)
    },
    handleAdd() {
      this.dialogVisible = true
      this.formData = {
        levels: [{value:''}]
      }
    },
    handleEdit(row) {
      this.formData = {...row}
      if (this.formData.levels) {
        let levels = this.formData.levels.split(',')
        this.formData.levels = levels.map(l => {
          return {value: l}
        })
      } else {
        this.formData.levels = [{value: ""}]
      }
      this.dialogVisible = true;
    },
    handleDelete(id) {
      this.$confirm('此操作不可恢复，确定删除吗？',{type:'warning'}).then(() => {
        this.$http.post('/api/other_cert_delete',{id}).then(res => {
          this.$message.success('删除成功')
          this.getlist();
        })
      })
    },
    getInfo() {
      this.$http.post("/api/get_teacher_info").then(res => {
        this.teacherInfo = res.data
      })
    },
    expandedTree(data) {
      this.expandedKeys = [];
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].arr.length; j++) {
          this.expandedKeys.push(data[i].arr[j].name);//循环data的数据，把对应要展开的节点name放入展开的数组中
        }
      }
    },
    getSchoolList() {
      this.$http.post("/api/school_list").then(res => {
        let SchoolList = res.data
        this.$http.post("/api/get_jiuye_tjschools").then(res2 => {
          for (let item of res2.data) {
            for (let s of SchoolList) {
              if (s.id == item.pmid) {
                s.hasData = true
              }
            }
          }
          this.SchoolList = SchoolList
          for (let item of SchoolList) {
            if (item.hasData) {
              this.setSchool(item.id)
              break
            }
          }
        })
      })
    },
    getlist() {
      this.dataList = []
      this.$http
        .post("/api/other_cert_list", {
          page: this.page.current_page,
          pagesize: this.page.per_page,
        })
        .then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            let rData = res.data.data
            this.dataList = rData;

            this.page = res.data.page || this.page
          }
        });
    },
    uploadFiles(e) {
      let loadInstance = this.$loading({
        lock: true,
        text: '导入中....',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      this.$http.post("/api/import_jnjd_table", {
        url: e.src,
        filename: e.fileName,
      }).then(res => {
        loadInstance.close()

        if (res.data.errors && res.data.errors.length > 0) {
          let html = ''
          for (let error of res.data.errors) {
            html += "<div style='font-size:13px'>" + error.msg + "</div>"
          }
          this.$alert(html, `未导入数据${res.data.errors.length}条`, {
            dangerouslyUseHTMLString: true,
            showCancelButton: true,
            cancelButtonText:"取消",
            distinguishCancelAndClose: true,
          });
        } else {
          this.$message.success("导入成功")
          this.dialogShow = false
          this.getlist()
        }

        this.dialogShow3 = false
        this.activeName = ""
        this.$nextTick(e => {
          this.activeName = "forth"
        })

      }).catch(e => {
        loadInstance.close();
      })
    },
    handlePageChange(page) {
      this.page.current_page = page
      this.getlist()
    },
    handleSizeChange(val) {
      this.page.current_page = 1;
      this.page.per_page = val;
      this.getlist()
    },
    setSchool(id) {
      this.schoolId = 0;
      this.tjData = null;
      this.searchForm.major_type = ""
      setTimeout(() => {
        this.schoolId = id
        this.getlist()
      }, 200)

    },
    submitForm() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let formData = {...this.formData}
          formData.tpmid = this.schoolId
          formData.levels = formData.levels.filter(l => l.value).map(m => m.value).join(',')
          this.$http.post('/api/other_cert_edit', formData).then(res => {
            this.dialogVisible = false
            this.getlist();
          })
        }
      })
    },
  }
};
</script>
<style type="text/less" lang="less" scoped>
.school {
  line-height: 30px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px 10px;
}

.school:hover {
  background-color: aliceblue;

}

.ckd {
  background-color: #547df2;
  color: #fff;
}

.ckd:hover {
  background-color: #547df2;
  color: #fff;
}
</style>
